const state = {
    // index_information :'',
    current:'',
    title:''

};

const mutations = {
    // set_index_information(state,val){
    //     state.index_information = val;
    // },
    set_current(state,val){
        state.current = val ;
    } ,
    set_title(state,val){
        state.title = val ;
    }

};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}
